export default __webpack_public_path__ + "img/titem_1.49512250.png";